<template>
    <div class="animated fade-in">

        <h1 class="display-4 font-weight-lighter">
            SuperForm Product Updates
            <div class="d-inline-block float-right" v-if="is_admin">
                <b-button-group class="float-left mr-2">
                    <b-button variant="outline-dark" squared v-b-tooltip.hover title="Create General Notification" @click="general_show = true"><font-awesome-icon :icon="['fal','plus']"></font-awesome-icon></b-button>
                    <b-button variant="outline-dark" squared v-b-tooltip.hover title="Global Messages" to="notifications/messages"><font-awesome-icon :icon="['fal','list']"></font-awesome-icon></b-button>
                </b-button-group>
                <b-dropdown class="float-left" text="View Examples">
                    <b-dropdown-item @click="viewExample('GeneralNotification')">General Notification</b-dropdown-item>
                    <b-dropdown-item @click="viewExample('OrderStatusChanged')">Order Status Changed</b-dropdown-item>
                    <b-dropdown-item @click="viewExample('EstimateStatusChanged')">Estimate Status Changed</b-dropdown-item>
                </b-dropdown>
            </div>
        </h1>

        <c-tabs class="my-3">
            <c-tab title="Newsletters">
                <newsletter-table></newsletter-table>
            </c-tab>
            <c-tab title="Orders">
                <notification-table
                    :clickable="!is_admin"
                    :type_whitelist="['OrderStatusChanged']"
                    :show_fields="is_admin ? null : ['name', 'created_at']"
                ></notification-table>
            </c-tab>
            <c-tab title="Estimates">
                <notification-table
                    :clickable="!is_admin"
                    :type_whitelist="['EstimateStatusChanged']"
                    :show_fields="is_admin ? null : ['name', 'created_at']"
                ></notification-table>
            </c-tab>
            <c-tab title="Other">
                <notification-table
                    :clickable="!is_admin"
                    :type_blacklist="['OrderStatusChanged', 'EstimateStatusChanged']"
                    :show_fields="is_admin ? null : ['type', 'name', 'created_at']"
                ></notification-table>
            </c-tab>
        </c-tabs>

        <c-modal scrollable :show.sync="example_show" title="Example" size="lg">
            <b-overlay :show="example_loading">
                <iframe frameborder="0" :src="example_src" width="100%" height="600"></iframe>
            </b-overlay>
            <template #footer=""><span></span></template>
        </c-modal>

        <c-modal scrollable :show.sync="general_show" title="Send Global Notification" size="lg">
            <b-input v-model="general_title" class="mb-2" placeholder="Title"></b-input>
            <b-form-tags input-id="general_emails" v-model="general_emails" placeholder="Add emails here (leaving this blank will email all users)" class="mb-2"></b-form-tags>
            <b-textarea v-model="general_message" placeholder="Message" style="height: 300px"></b-textarea>
            <template #footer="">
                <b-button-group class="float-left mr-2">
<!--                    <b-button variant="outline-dark" squared @click="general_show = false"><font-awesome-icon :icon="['fal','times']"></font-awesome-icon></b-button>-->
                    <b-button variant="outline-success" squared @click="sendGeneralNotification"><font-awesome-icon :icon="['fal','envelope']"></font-awesome-icon></b-button>
                </b-button-group>
            </template>
        </c-modal>

    </div>
</template>

<script>
  import Notification from "../../models/Notification";
  import ToastNotifications from "../../components/shared/mixins/ToastNotifications";
  import NewsletterTable from "../../components/notifications/NewsletterTable";
  import NotificationTable from "../../components/notifications/NotificationTable";

  export default {
    name: 'NotificationTabs',
    components: {NotificationTable, NewsletterTable},
    mixins: [ToastNotifications],
    data() {
      return {
        example_show: false,
        example_loading: true,
        example_src: null,

        general_show: false,
        general_message: null,
        general_title: null,
        general_emails: null,

        is_admin: this.$store.getters.isAdmin,
      };
    },
    methods: {
      viewExample(type) {
        this.example_loading = true;
        this.example_show = true;
        Notification.api().example(type).then((response) => {
          let data = response.response.data;
          this.example_src = 'data:text/html;base64,' + btoa(unescape(encodeURIComponent(data)));
          let file = new Blob([data], {type: 'text/html'});
          let urlCreator = window.URL || window.webkitURL;
          let url = urlCreator.createObjectURL(file);
          this.example_src = url;
          this.example_loading = false;
        });
      },
      sendGeneralNotification() {
        Notification.api().general(this.general_message, this.general_title, this.general_emails).then(() => {
          this.quickSuccessToast('General notification was sent', 'The message(s) will reach them shortly.');
          this.general_show = false;
          this.general_message = false;
          this.general_title = false;
          this.refresh = true;
        });
      }
    }
  }
</script>